import { render, staticRenderFns } from "./editSpeakerEdition.vue?vue&type=template&id=87d2df8c"
import script from "./editSpeakerEdition.vue?vue&type=script&lang=js"
export * from "./editSpeakerEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports